import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {POSITION_QUALITIES, JOB_POSITIONS} from './JobPositions'

class JoinUs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        return (
            <section id="join-us" className="bg-dark">
                <div className="container text-white">
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <h2 className="section-heading">Join Us!</h2>
                            <hr className="my-4"/>
                            <p>
                                We are looking for talented software engineers to join us on our mission!
                            </p>
                            <p>
                                Currently we only have contracting opportunities available,
                                please click below for open positions:
                            </p>
                            <br/>
                            <Button className="btn btn-light btn-xl js-scroll-trigger" onClick={this.toggle}>
                                Available Positions
                            </Button>
                        </div>
                    </div>
                </div>
                <Modal id="available-positions-modal" isOpen={this.state.modal} toggle={this.toggle}
                       className="modal-lg">
                    <ModalHeader toggle={this.toggle}>Available Positions</ModalHeader>
                    <ModalBody>
                        <div>
                            <p>
                                Novotec team members are passionate technologists who understand the importance of
                                collaboration and creating value. We primarily focus on latest technologies and software
                                development in Java (Spring), Ruby (Rails), and Javascript (Angular, React).
                            </p>
                            <p>
                                We are looking for new team members to join our team! Some important qualities we look
                                for in potential clients are:
                            </p>
                            <ul>
                                {
                                    POSITION_QUALITIES.map((quality, index) => {
                                        return (
                                            <li key={index}>{quality}</li>
                                        );
                                    })
                                }
                            </ul>
                        </div>
                        <hr/>
                        <div>
                            <p>
                                See below for available opportunities with Novotec:
                            </p>
                            {
                                JOB_POSITIONS.map((position, index) => {
                                    return (
                                        <div key={index}>
                                            <div className="card">
                                                <div className="card-header">
                                                    <p className="float-right text-secondary">
                                                        <FontAwesomeIcon className="text-info mr-1"
                                                                         icon={["fas", "location-arrow"]}/>
                                                        {position.location}
                                                    </p>
                                                    <h5>{position.icon} {position.title}</h5>
                                                </div>
                                                <div className="card-body">
                                                    <p>Qualifications: </p>
                                                    <ul>
                                                        {
                                                            position.qualifications.map((qualification, index) => {
                                                                return (
                                                                    <li key={index}>{qualification}</li>
                                                                );
                                                            })
                                                        }
                                                    </ul>
                                                    <p>
                                                        To apply, send your resume to
                                                        <a href="mailto:careers@novotec.io"> careers@novotec.io</a>.
                                                        Also, feel free to share your blog, public GitHub/GitLab
                                                        profile, or anything else in your portfolio!
                                                    </p>
                                                </div>
                                            </div>
                                            {JOB_POSITIONS.length - 1 !== index ? <br/> : <div/>}
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggle}>Close</Button>
                    </ModalFooter>
                </Modal>
            </section>
        );
    }
}

export default JoinUs;


// WEBPACK FOOTER //
// ./src/js/App/JoinUs/JoinUs.js